import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAttributionCapture } from '../utils/attribution';

/**
 * Effect-only tracker that runs initAttributionCapture() on initial
 * mount AND on every client-side route change. This guarantees:
 *   - First-touch is captured on the very first page render.
 *   - Last-touch is refreshed if the user later clicks an ad link
 *     mid-session that lands on a new in-app route carrying UTMs /
 *     fbclid / gclid in the query string.
 *
 * Renders nothing. Never throws.
 */
export default function AttributionTracker() {
  const location = useLocation();
  useEffect(() => {
    try { initAttributionCapture(); } catch (_) { /* never break the page */ }
  }, [location.pathname, location.search]);
  return null;
}
